<template>
  <vContent :sysId=eId :fmtId=fmtId />
</template>

<script>
import vContent from '@/components/common/ContentView.vue'
export default {
  name: 'finLocation',
  data () {
    return {
      eId: 0,
      fmtId: 9
    }
  },
  components: {
    vContent
  },
  computed: {
    setting () {
      return this.$store.getters.getSetting
    }
  },
  created () {
    this.eId = this.setting.enrollID[0].codeName;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FinLocationView.vue